
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/getting-started/business",
      function () {
        return require("private-next-pages/getting-started/business.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/getting-started/business"])
      });
    }
  